<template>
    <div id="main-content">
        <navBar/>
        <SideMenu/>
<!--        <div style="background:red;color:black;padding:10px">-->
<!--            <marquee behavior="scroll" direction="left">Maintenance Period-->
<!--                From 16 Oct 10:00pm till 17 Oct 2:00am (Singapore time)</marquee>-->
<!--        </div>-->
        <div v-if="arrMaintenance.length > 0" v-html="arrMaintenance[0].VerValue"></div>
        <slot/>
    </div>

</template>

<script>
    import navBar from "../components/Nav";
    import SideMenu from "../components/SideMenu";
    // import Header from "../components/Header";
    import DataSource from "../data/datasource";
    import Cookies from "js-cookie";

    export default {
        name: 'MainContent',
        components: {
            navBar,
            SideMenu
            // Header,
        },
        data() {
            return {
                appType: "Kagami",
                arrMaintenance: [],
            };
        },
        async created() {
            if (Cookies.get('authToken') !== null && Cookies.get('authToken') !== undefined && Cookies.get('authToken') !== ''&& Cookies.get('authToken') !== 'undefined') {
                await this.getMaintenanceMsg();
            }
        },
        methods: {
            async getMaintenanceMsg() {
                this.$vs.loading();

                try {
                    const response = await DataSource.shared.getSystemValue(this.appType);
                    if (response) {

                        if (response.code === '2') {
                            console.log('getSystemValue returns 2');
                        } else if (response.code === '88') {
                            // window.location.replace('/');
                        } else if (response.code === '99') {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('Error! Please try again later')
                            });
                        } else {
                            this.arrMaintenance = response.Table;
                        }

                        // console.log(this.arrMaintenance, "resp");
                    }
                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },
        },
    };
</script>

<style scoped>
</style>

<style>


</style>
